<template>
    <ui-modal>
        <template #header>
            <h3 v-text="'Nieprawidłowy numer plomby'" class="text-center" />
        </template>

        <page-preloader v-if="isLoading" min-height="200px" />

        <div v-else class="text-center p-3">
            <a-icon
                icon="WarningFull"
                width="2.5rem"
                height="2.5rem"
                class="text-warning"
            />

            <h5 v-html="detailsText" class="font-weight-normal my-3" />
            <h5 v-if="extraText" v-text="extraText" class="font-weight-normal" />
            <h5 class="font-weight-normal text-orange pt-3">
                <template v-if="isUnknownPrefix">Czy chcesz kontynuować?</template>
                <template v-else>
                    Czy na pewno chcesz kontynuować z numerem plomby
                    <strong>{{ sealNumber }}</strong>?
                </template>
            </h5>
        </div>

        <template #footer>
            <the-btn
                class="btn-outline-custom"
                text="Nie, wróć"
                :disabled="isLoading"
                @click="args.onRejectBtn(args)"
            />
            <the-btn
                class="btn-danger"
                text="Tak, kontynuuj"
                :disabled="isLoading"
                @click="onAccept"
            />
        </template>
    </ui-modal>
</template>

<script>
import bagsMixin from '@/components/drs/stores/bags/bags.mixin'
import { SEAL_WARNING } from '@/helpers/seal-validation'

export default {
    mixins: [bagsMixin],

    data: () => ({
        isLoading: false
    }),

    computed: {
        args() {
            return this.$store.getters.getModal.args
        },

        bag() {
            return this.args.bag
        },

        sealNumber() {
            return this.args.sealNumber
        },

        isUnknownPrefix() {
            return this.sealWarning === SEAL_WARNING.UNKNOWN_PREFIX
        },

        detailsText() {
            const warning = this.sealWarning

            if (warning === SEAL_WARNING.UNKNOWN_PREFIX) {
                return 'Wprowadzony numer plomby nie jest powiązany z żadnym operatorem.<br/>Taki worek możesz wydać jedynie transportem własnym.'
            }

            if (warning === SEAL_WARNING.INVALID_SEAL) {
                return 'Wprowadzony numer plomby jest nieprawidłowy. Sprawdź, czy warunek 15 znaków oraz cyfry kontrolnej został spełniony.'
            }

            const { name, prefix } = this.bag.preferredOperator || {}
            return `Przedrostek (prefiks) plomby nie należy do preferowanego operatora tej frakcji. Plomba preferowanego operatora ${name} zaczyna się od ${prefix}.`
        },

        extraText() {
            if (this.sealWarning !== SEAL_WARNING.OTHER_OPERATOR_INVALID) return null

            return 'Dodatkowo, upewnij się, czy warunek 15 znaków oraz prawidłowej cyfry kontrolnej został spełniony.'
        }
    },

    methods: {
        async onAccept() {
            this.isLoading = true

            await this.args.onAcceptBtn()

            this.isLoading = false
            this.$emit('close-modal')
        }
    }
}
</script>